import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights",
)({
  staticData: { title: "Flights" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/flights/flights.tsx"),
    "Flights",
  ),
})
